<template>
  <div v-if="loading" class="bg-segment-primary-color white loading-bg">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw white"></i>
    <span>Aguarde</span>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-5 order-md-1 order-1">
        <UnitCard @contracts="handleContracts" />
      </div>
      <div class="col-12 col-md-7 order-md-1 order-2">
        <span id="span_scroll" :ref="setTopRef"></span>
        <button id="btn_scroll" type="button" style="display: none;" @click="scrollToBottom">.</button>
        <component :is="currentComponent" v-if="currentComponent && contracts" :contracts="contracts" />
      </div>
    </div>
  </div>
  <chat-bot />
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

import UnitCard from './components/UnitCard.vue';
import PrincipalCard from './components/PrincipalCard.vue';
import UpdateUser from '../Users/UpdateUser.vue';
import TechnicalAssistance from '../TechnicalAssistance/TechnicalAssistance.vue';
import CustomerService from '../CustomerService/CustomerService.vue';
import Schedule from '../Schedule/Schedule.vue';
import ContactUs from '../ContactUs/ContactUs.vue';
import FinancialCenter from '../FinancialCenter/FinancialCenter.vue';
import DetailedExtract from '../FinancialCenter/components/DetailedExtract.vue';
import InfoBuilding from '../InfoBuilding/InfoBuilding.vue';
import Customization from '../Customization/Customization.vue';
import DocsAndCommunication from '../DocsAndCommunication/DocsAndCommunication.vue';
import AllNotifications from '../Notifications/AllNotifications.vue';
// import ChatBot from "../Home/Chatbot.vue";

export default {
  components: {
    UnitCard,
    PrincipalCard,
    UpdateUser,
    TechnicalAssistance,
    CustomerService,
    Schedule,
    ContactUs,
    FinancialCenter,
    DetailedExtract,
    InfoBuilding,
    Customization,
    DocsAndCommunication,
    AllNotifications,
    // ChatBot
  },
  setup() {
    const store = useStore();
    const contracts = ref(null);
    const loading = ref(true);
    const currentComponent = computed(() => {
      const component = store.getters.getCurrentComponent;
      return component ? component : 'PrincipalCard';
    });
    const top = ref(null);

    const setTopRef = el => {
      top.value = el;
    };

    const scrollToBottom = () => {
      if (top.value) {
        top.value.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const handleContracts = data => {
      contracts.value = data;
    };

    const getContracts = async () => {
      try {

        let localStorageAllContracts = JSON.parse(localStorage.getItem('allContracts'))
        // let localStorageCurrentContracts = localStorage.getItem('currentContract')
        if (localStorageAllContracts) {
          handleContracts(localStorageAllContracts[0]);
          loading.value = false;
          return;
        }

        const response = await axios.get('/contract-ws?page=0&size=10');
        store.commit('updateContract', response.data.result.contratos[0]);
        store.commit('updateAllContracts', response.data.result.contratos);
        handleContracts(response.data.result.contratos[0]);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      getContracts();
    });

    return {
      contracts,
      currentComponent,
      loading,
      handleContracts,
      scrollToBottom,
      setTopRef
    };
  }
};
</script>

<style scoped>
.loading-bg {
  color: white;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;
}
</style>
